import type { FormSchemaType } from '@/schema';
import { FieldInput, Question } from '@workspace/core-ts/components';
import { SmartFormGlobal, useGlobalForm, useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { ToutMotards } from '@workspace/core-ts/icons-amo';
import { isValidImmatriculation, normalizeEuro } from '@workspace/utils';
import { useFormContext } from 'react-hook-form';
import { useDevisFormatedData } from './tarification/use-devis-formated-data';

export default function Recapitulatif() {
  const methods = useSmartFormGlobal<FormSchemaType>();

  return (
    <SmartFormGlobal
      {...methods}
      className="max-w-2xl mx-auto"
    >
      <Question disabledAutoNext>
        <Question.Header>
          <ToutMotards />
          <Question.Title>Récapitulatif de votre flotte</Question.Title>
        </Question.Header>

        <Vehicules />
        <BulleInfoRecapitulatif />
      </Question>
    </SmartFormGlobal>
  );
}

function BulleInfoRecapitulatif() {
  const methods = useFormContext<FormSchemaType>();
  const { totalPrimeMensuelle, totalPrimeAnnuelle, totalAttentat } = useDevisFormatedData();

  const FractionnementChoisi = methods.watch('DemandeTarif.Police.FractionnementChoisi');

  return (
    <div className="bg-card rounded-lg py-4 text-sm w-full">
      <div className="flex items-center justify-between gap-4 px-4">
        <div>
          <h3 className="text-sm">Votre total (TTC)</h3>
          <p className="text-[11px] text-gray-500">Incluant les frais de dossier {totalAttentat > 0 && `et la taxe attentat`}</p>
        </div>
        <p className="text-primary font-medium">
          {FractionnementChoisi === 'M' ? (
            <>
              {normalizeEuro(totalPrimeMensuelle)} <span className="text-xs text-gray-500 font-normal">/mois</span>
            </>
          ) : (
            <>
              {normalizeEuro(totalPrimeAnnuelle)} <span className="text-xs text-gray-500 font-normal">/an</span>
            </>
          )}
        </p>
      </div>
    </div>
  );
}

function Vehicules() {
  const methods = useFormContext<FormSchemaType>();
  const FractionnementChoisi = methods.watch('DemandeTarif.Police.FractionnementChoisi');
  const { initialState } = useGlobalForm();
  const isAvenant = methods.watch('DemandeTarif.ActeGestion') === 'AV';

  // const Vehicules = methods.watch('DemandeTarif.ListeVehicules');
  // const TarifVehicules = methods.watch('Tarif.ListeVehicules');
  const { VehiculesMap } = useDevisFormatedData();

  // totalPriceVehiculeMensuel && totalPriceVehiculeAnnuel

  return (
    <div className="w-full space-y-5">
      {VehiculesMap.map((vehicule, index) => (
        <div
          className="bg-card rounded-lg py-4 text-sm"
          key={index}
        >
          <div className="flex items-center justify-between gap-4 px-4">
            <h3 className="text-base">
              <span className="text-primary">Véhicule {index + 1}</span> ({vehicule.Marque} {vehicule.Modele})
            </h3>
            <p className="text-primary font-medium">
              {FractionnementChoisi === 'M' ? (
                <>
                  {normalizeEuro(vehicule.totalPriceVehiculeMensuel)} <span className="text-xs text-gray-500 font-normal">/mois</span>
                </>
              ) : (
                <>
                  {normalizeEuro(vehicule.totalPriceVehiculeAnnuel)} <span className="text-xs text-gray-500 font-normal">/an</span>
                </>
              )}
            </p>
          </div>
          <dl className="grid grid-cols-2 gap-1 sm:gap-2 mt-3 text-xs px-4">
            <dt>Mise en circulation</dt>
            <dd>{vehicule.DateMEC}</dd>
            <dt>Achat du véhicule</dt>
            <dd>{vehicule.DateAchatVehicule}</dd>
            <dt>Code postal & ville de stationnement</dt>
            <dd>
              {vehicule.CodePostalGarage} {vehicule.VilleGarage}
            </dd>
          </dl>

          <hr className="my-4 border-white" />

          <dl className="grid grid-cols-2 gap-1 sm:gap-2 mt-3 text-xs px-4">
            <dt>Formule choisie</dt>
            <dd>{vehicule.selectedFormule.LibelleFormule}</dd>
            <dt>Options choisies</dt>
            {vehicule.selectedOptions.length > 0 ? (
              <dd>
                <ul>
                  {vehicule.selectedOptions.map((option, index) => (
                    <li key={index}>{option.LibelleGarantie}</li>
                  ))}
                </ul>
              </dd>
            ) : (
              <dd>-</dd>
            )}
          </dl>

          <hr className="my-4 border-white" />
          <FieldInput
            className="px-4"
            disabled={isAvenant ? initialState?.DemandeTarif?.ListeVehicules?.[index] !== undefined : undefined}
            label="Immatriculation"
            name={`DemandeTarif.ListeVehicules.${index}.Immatriculation`}
            placeholder="AA 123 BB"
            validation={{
              validate: {
                isValidImmatriculation,
              },
              onChange: (e) => {
                const value = e.target.value;

                // ONLY DIGITS AND LETTERS
                e.target.value = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
              },
            }}
          />
        </div>
      ))}
    </div>
  );
}
